import React, { useEffect } from 'react';
import { redirectToIdentityLogin } from '../contexts/AuthContext';

/**
 * Login page — Vault no longer collects credentials.
 * Immediately redirects to the TW1 Identity Platform.
 */
export default function Login() {
  useEffect(() => {
    // Microtask delay so the loading UI paints first
    const t = setTimeout(() => { redirectToIdentityLogin(); }, 50);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center relative overflow-hidden login-animated-bg"
      data-testid="login-page"
    >
      <style>{`
        @keyframes loginGradient {
          0% { background-position: 0% 0%; }
          25% { background-position: 100% 50%; }
          50% { background-position: 50% 100%; }
          75% { background-position: 0% 50%; }
          100% { background-position: 0% 0%; }
        }
        .login-animated-bg {
          background: linear-gradient(135deg, #0D1117, #161B22, #1B2A6B, #0D1117, #161B22);
          background-size: 400% 400%;
          animation: loginGradient 15s ease infinite;
        }
      `}</style>

      <div className="relative w-full max-w-[420px] mx-4">
        <div
          className="rounded-2xl p-10 shadow-2xl border border-white/[0.06] text-center"
          style={{
            background: 'rgba(22, 27, 34, 0.65)',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
          }}
        >
          <img
            src="/images/logo-full-400.png"
            alt="Truckwash 1 Group"
            className="mx-auto mb-3"
            style={{ width: '200px', height: 'auto' }}
            data-testid="login-logo"
          />
          <p className="text-sm font-bold uppercase tracking-[0.3em] text-[#2E75B6] mb-6">
            VAULT
          </p>
          <div className="mx-auto w-12 h-[2px] rounded-full mb-6" style={{
            background: 'linear-gradient(90deg, transparent, #3B82F6, transparent)',
          }} />
          <p className="text-sm text-[#E6EDF3] mb-1" data-testid="login-redirect-message">
            Bezig met doorsturen naar TW1 Identity...
          </p>
          <p className="text-[11px] text-[#8B949E] mt-2">
            Je wordt ingelogd via id.truckwash1.cloud
          </p>
          <div className="mt-6 inline-block w-5 h-5 rounded-full border-2 border-[#3B82F6]/40 border-t-[#3B82F6] animate-spin" />
        </div>
      </div>
    </div>
  );
}
